<template>
  <div class="outer-wrapper">
      <van-tabs v-model="currentTab">
        <van-tab title="待接收任务" name="currentTask">
          <van-search
            v-model="myTaskKeyword"
            placeholder="请输入关键字"
            input-align="center"
            @search="onMyTaskSearch"
          />
          <van-list
            v-model="myTaskTable.loading"
            :finished="myTaskTable.finished"
            finished-text="没有更多了"
            :error.sync="myTaskTable.error"
            error-text="请求失败，点击重新加载"
            @load="onMyTaskLoad"
          >
            <van-cell
              v-for="(item, index) in myTaskTable.tivdata"
              :key="index + 'su'"
              :title="item.name"
              @click="chooseMyTask(item)"
              is-link
            >
              <span class="cell-item">{{item.plan_complete_time?item.plan_complete_time.split(' ')[0]:'-'}}</span>
            </van-cell>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
import { textTrans } from "@/mixins/TextTrans.js";

function myTaskTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20,
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [],
  };
}

function orderTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20,
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [],
  };
}

export default {
  name: "myTask",
  components: {},
  mixins: [textTrans],
  data() {
    return {
      currentTab: 0,
      askData: "acceptableTaskList",
      myTaskTable: myTaskTableFac(),
      orderTable: orderTableFac(),
      orderShow: false,
      currentMyTask: {},
      myTaskKeyword: "",
    };
  },
  watch: {},
  computed: {},
  created() {

  },
  mounted(){
    this.onMyTaskLoad();
  },
  methods: {
    onMyTaskSearch() {
      this.myTaskTable = myTaskTableFac();
      this.onMyTaskLoad();
    },
    onMyTaskLoad() {
      this.myTaskTable.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.myTaskTable.Tpage,
          userToken: userToken,
          ask_data: this.askData,
          selected_list: [],
          keyword: this.myTaskKeyword,
        })
        .then((response) => {
          for (let ele of response.data.res_record) {
            this.myTaskTable.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.myTaskTable.Tpage.currentSize
          ) {
            this.myTaskTable.finished = true;
          }
          this.myTaskTable.loading = false;
          this.myTaskTable.Tpage.currentPage++;
        });
    },
    chooseMyTask(val) {
      window.location.href = '/task/'+val.enid;
    },
  },
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-left: 0.6rem;
}

.op {
  outline: none;
  border: 1px solid #eee;
  color: #fff;
  background: rgb(11, 155, 18);
  font-weight: 400;
  height: 1rem;
  position: relative;
  top: 0.05rem;
  padding: 0.15rem 0.5rem;
  border-radius: 0.2rem;
}
.deny {
  background: rgb(228, 46, 14);
  margin-left: 0.5rem;
}

.text-wrapper {
  padding: 0.1rem 0.5rem;
}
.text-wrapper-con {
  padding: 1rem 0 1rem 2rem;
}

.textarea {
  width: 100%;
  height: 7rem;
}
.bold-text {
  font-weight: 600;
  color: #666;
}
.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.6rem;
}
.button-wrapper {
  padding: 2rem;
  text-align: center;
}
.radio-item {
  margin-top: 1rem;
  margin-left: 30%;
}

.cell-title{
  overflow: hidden;
  word-break: break-all;
}
</style>